const HTML_ESCAPES = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};

const escapeHtml = text => text.replace(/[&<>"']/g, char => HTML_ESCAPES[char]);

// Converte texto puro (parágrafos separados por linha em branco) em HTML seguro para o CKEditor.
export const textToHtml = text => {
  if (!text) return "";

  return text
    .replace(/\r\n/g, "\n")
    .split(/\n\s*\n/)
    .map(paragraph => paragraph.trim())
    .filter(Boolean)
    .map(paragraph => `<p>${escapeHtml(paragraph).replace(/\n/g, "<br>")}</p>`)
    .join("");
};

export default textToHtml;
